export const doctors = '/doctors';
export const doctorUrl = (id: number) => `/doctors/${id}`;
export const download = 'doctors/download';
export const addDoctor = (serviceProviderId: number,
  doctorId: number) => `/service-providers/${serviceProviderId}/doctors/${doctorId}/schedule`;
export const deleteDoctor = (doctorId: number) => `/doctors/${doctorId}`;
export const syndicateIDApproval = (id: number) => `/doctors/${id}/syndicate-id-url`;
